// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KeSHAfVUq0d0TKSCDYw7 {
  display: inline-block;
  background-color: transparent;
  color: var(--dry-color);
  padding: 0.4em 1em;
  border: var(--dry-border-width) var(--dry-border-style) var(--dry-border-color);
  border-radius: var(--dry-border-radius);
  --dry-shadow: #0000000d 0px 0px 0px 1px;
  box-shadow: var(--dry-shadow);
  cursor: pointer;
  transition: all 0.3s;
}
.KeSHAfVUq0d0TKSCDYw7:hover:not(:disabled) {
  border-color: var(--dry-primary);
}
.KeSHAfVUq0d0TKSCDYw7[data-primary="true"] {
  background-color: var(--dry-primary);
  color: var(--dry-primary-text);
  border-color: var(--dry-primary);
}
.KeSHAfVUq0d0TKSCDYw7[data-primary="true"]:hover:not(:disabled) {
  background-color: var(--dry-primary-highlight);
  color: var(--dry-primary-highlight-text);
  border-color: var(--dry-primary-highlight);
}
.KeSHAfVUq0d0TKSCDYw7:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.KeSHAfVUq0d0TKSCDYw7:disabled[data-primary="true"] {
  color: var(--dry-color);
}
.KeSHAfVUq0d0TKSCDYw7[hidden] {
  display: none;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `KeSHAfVUq0d0TKSCDYw7`
};
export default ___CSS_LOADER_EXPORT___;
